import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import fileDownload from 'js-file-download';

import { useEmailApiClient } from '@/api/clients/useEmailApiClient.util.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Req = {
  emailId: string;
  externalAttachmentId: string;
};

type Response = void;

type Return = {
  getAttachment: (req: Req) => Promise<Response>;
  isGettingAttachment: boolean;
};

export const useGetAttachment = (): Return => {
  const { emailReaderApi } = useEmailApiClient();
  const { userId } = useUserContext();
  const { isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    mutationFn: async req => {
      const response = await emailReaderApi.getAttachment(
        userId,
        req.emailId,
        req.externalAttachmentId,
        { responseType: 'blob' },
      );
      const fileName =
        response.headers['content-disposition'].match(/attachment; filename=(.*)/)[1];
      fileDownload(response.data, fileName);
    },
  });
  return {
    getAttachment: mutateAsync,
    isGettingAttachment: isPending,
  };
};
